import type {EntropySource} from './types';

/** The caller supplies cryptographic entropy online; no browser/server APIs live in the rules engine. */
export function randomIndex(length:number,entropy:EntropySource):number {
  if(!Number.isInteger(length)||length<1||length>0x100000000)throw new Error('Invalid random range');
  const limit=Math.floor(0x100000000/length)*length;
  for(let attempts=0;attempts<1024;attempts++){
    const value=entropy.nextUint32();
    if(!Number.isInteger(value)||value<0||value>0xffffffff)throw new Error('Entropy must supply an unsigned 32-bit integer');
    if(value<limit)return value%length;
  }
  throw new Error('Entropy source failed rejection sampling');
}
export function shuffle<T>(values:T[],entropy:EntropySource):void {
  for(let i=values.length-1;i>0;i--){const j=randomIndex(i+1,entropy);[values[i],values[j]]=[values[j]!,values[i]!];}
}
export function opaqueInstanceId(entropy:EntropySource):string {
  return Array.from({length:4},()=>randomIndex(0x100000000,entropy).toString(16).padStart(8,'0')).join('');
}
export function seededEntropy(seed:number):EntropySource {
  let state=(seed>>>0)||0x9e3779b9;
  return {nextUint32(){let x=state|0;x^=x<<13;x^=x>>>17;x^=x<<5;state=x>>>0;return state;}};
}
